import { Skeleton } from "@mui/material";
import styled from "styled-components";

export const RecordCardSkeletonContainer = styled.div`
  padding: 12px;
  margin-bottom: 4px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #d0d0d0;
  }
`;

export const RecordHeaderSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RecordTitleSkeleton = styled(Skeleton).attrs({
  height: 16,
  width: "70%",
})`
  border-radius: 4px;
`;

export const RecordSubtitleSkeleton = styled(Skeleton).attrs({
  height: 14,
  width: "50%",
})`
  border-radius: 4px;
`;

export const RecordDurationSkeleton = styled(Skeleton).attrs({
  height: 14,
  width: 60,
})`
  border-radius: 4px;
`;

export const RecordStatusSkeleton = styled(Skeleton).attrs({
  height: 20,
  width: 70,
})`
  border-radius: 10px;
`;

export const RecordBottomSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
`;
